export const homeObjOne = {
  lightBg: false,
  imgStart: "",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description:
    "We are an online service connecting Serbian brands with the world, offering a wide range of high-quality products and unique designs.",
  headline: "Lead Generation Online Service",
  lightText: true,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/Serbeatimg.jpg"),
  alt: "Image",
  start: "",
};

export const homeObjTwo = {
  lightBg: true,
  imgStart: "start",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "If you have a registered offer for any product on the domestic market, please contact us.",
  headline: "Come Work With Us",
  lightText: false,
  topLine: "SerBeat Online",
  primary: false,
  img: require("../../images/Simg01.jpg"),
  alt: "Image",
  start: "true",
};

export const homeObjThree = {
  lightBg: true,
  imgStart: "start",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "Serbia has a long-standing tradition of producing local goods from authentic ethnogeographic regions. Over centuries, it has built its reputation for quality and innovation. The Serbeat platform combines knowledge, skills, and creativity to support small Serbian enterprises by uniting brands. This provides a competitive edge and easier access to both domestic and international markets, aiming to create effective business opportunities for all its members.",
  headline: "We Unite Serbian Brands",
  lightText: false,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/Simg12.jpg"),
  alt: "Image",
  start: "true",
};

export const homeObjFour = {
  lightBg: false,
  imgStart: "",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description:
    "Our goals and strategies are shaped by our vision to connect Serbian brands with the world. By creating a stable strategy based on the needs of our entrepreneurs, we have set objectives necessary to achieve this vision: to ensure stability and continuity in development, to provide support along the way, and to stand by our partners as they grow from small producers to well-known Serbian brands.",
  headline: "Goals And Strategies",
  lightText: true,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/svg-3.svg").default,
  alt: "Image",
  start: "",
};
